export default __webpack_public_path__ + "static/media/pengumuman-semifinal.ef1b01e0.png";